import * as Storage from '@app/lib/storage'

import type * as PatientList from '../patient-list/state'
import type * as Today from '../today/state'
import type * as VisitList from '../visit-list/state'

type UserPreferences = {
  patientList?: Partial<PatientList.State>
  today?: Partial<Today.State>
  visitList?: Partial<VisitList.State>
}

export type AllUserPreferences = Record<string, UserPreferences>

export function getAllUserPreferences(): AllUserPreferences {
  return Storage.getObject('userPreferences') ?? {}
}

export function getUserPreferences(userId: string): UserPreferences {
  const allUserPreferences = getAllUserPreferences()
  return allUserPreferences[userId] ?? {}
}

export function patchUserPreferences(
  userId: string,
  userPreferences: UserPreferences,
) {
  const allUserPreferences = getAllUserPreferences()
  const existingUserPreferences = getUserPreferences(userId)
  Storage.setObject('userPreferences', {
    ...allUserPreferences,
    [userId]: {
      ...existingUserPreferences,
      ...userPreferences,
    },
  })
}
